const $ = window.$;


export default class Model {
  constructor() {
    this.state = {
      winHeight: 0, // ページの高さ
      scroll: 0, // ページのスクロール量
      isSP: true,
      headerHeight: $('#js-header').height(),
      contentsNumArray: [], // 各コンテンツのoffsettop格納用
      circleWidthArray: [110, 150, 180, 155, 355, 185, 342, 190], // ふわふわサークルの半径格納用
    }

    this.setInitialState();
  }



// -----------------------------------------------------------------
// state 初期化
// @method setInitialState
// -----------------------------------------------------------------
  setInitialState() {

    // window高さ設定
    const _setWinHeight = () => {
      this.state.winHeight = $(window).height();
    }

    // 各コンテンツのoffset配列作成
    const _setContentsArray = () => {
      $('.js-phiolo-contents').each((i, el) => {
        this.state.contentsNumArray.push($(el).offset().top);
      });
    }
    
    // PC SP振り分け
    const _setDevice = () => {
      const w = $(window).width();
      if(w > 980)
        this.state.isSP = false;
      else
        this.state.isSP = true;
    };

    _setDevice();

    $(window).on('load', () => {
      _setWinHeight();
      _setContentsArray();
    });
  }



// -----------------------------------------------------------------
// 
// @method setState
// -----------------------------------------------------------------
  setState(type) {
    switch(type) {
      case 'scroll':
        this.state.scroll = $(window).scrollTop();
        break;
      default:
        break;
    }
  }



// -----------------------------------------------------------------
// 
// @method changeScroll
// -----------------------------------------------------------------
  changeScroll() {
    this.setState('scroll');
    this.judgeAnimation();
  }



// -----------------------------------------------------------------
// 
// @method getScroll
// -----------------------------------------------------------------
  getScroll() {
    return this.state.scroll;
  }



// -----------------------------------------------------------------
// 
// @method judgeAnimation
// -----------------------------------------------------------------
  judgeAnimation() {
    this.state.contentsNumArray.forEach((el, i) => {
      if(this.getScroll() > this.state.contentsNumArray[i] - (this.state.headerHeight + 100)) {
        $('#js-philoPage').trigger('animation', [i]);
      }
    });
  }

}


/** WEBPACK FOOTER **
 ** ./htdocs_dev/js/model/philosophy.js
 **/